// Libs
import React from 'react'
import { NavLink } from 'react-router-dom'

// CSS
import "./styles.scss"

const Links = ({ fontSize, options }) => {
  return (
    <div className="links" >
      {options.map(option => {
        const { to, text, active, onClick } = option

        return <NavLink
          key={text}
          to={to ? to : ""}
          activeClassName="links__link--active"
          className={active ? 'links__link links__link--active' : 'links__link'}
          onClick={onClick}>{text}</NavLink>
      })}
    </div>
  )
}

export default Links
